const lowerCase = (str) => {
    return str.toLowerCase();
};

const videoPlayPromise = (video) => {
    let playPromise = video.play();

    $(video).on("waiting", function () {
        $(video).parent().addClass("buffering");
    });

    // remove buffering
    $(video).on("playing", function () {
        $(video).parent().removeClass("buffering");
    });

    // check swiper is not active, buffering video temporarily hide
    $(video).on("pause", function () {
        $(video).parent().removeClass("buffering");
    });

    if (playPromise !== undefined) {
        playPromise
            .then((_) => {
                // Automatic playback started!
                // Show playing UI.
            })
            .catch((error) => {
                // Auto-play was prevented
                // Show paused UI.
                console.log("error", error);
            });
    }
};

export { lowerCase, videoPlayPromise };
